import { useHistory } from "react-router-dom";

import HeaderReportMp from "../../../../Components/ComponentsMarketplace/HeaderReportMp";
import ButtonsMap from "../../../../Components/ComponentsMarketplace/ButtonsMap";

import {
  Container,
  SizeContainer,
  InternalMenu,
  RoundContainer,
  H2RoundContainer,
  ParagraphRoundContainer,
  MainRoundContainer,
} from "./style";
import { useReportWeeklyMarket } from "../../../../providers/ReportWeeklyMarket";
import Loading from "../../../../Components/Loading";
import { useEffect } from "react";
import { useUser } from "../../../../providers/UserContext";

const WeeklyReportSales = () => {
  const history = useHistory();
  const { marketPlace, jogo } = useUser()
  const { reportWeeklyMarket, loading, fetchReportWeeklyMarket, setReportWeeklyMarket } = useReportWeeklyMarket()

  useEffect(() => {
    setReportWeeklyMarket({
      sales: [],
      purchasesInProgress: [],
      purchasesDone: []
    })
    if (!marketPlace?.supermercado || !jogo?.jogo) return
    fetchReportWeeklyMarket()
  }, [marketPlace, jogo])

  return (
    <Container>
      <SizeContainer>
        <HeaderReportMp title="RELATÓRIOS" pathImg="./images/calendar.svg" />
        <InternalMenu>
          {/* <button onClick={() => history.push("/weeklyReportStock")}>
            <img src="./images/stock_Mp.svg" alt="stock_Mp" />
          </button> */}
          <button onClick={() => history.push("/weeklyReportPurchases")}>
            <img src="./images/purchase_button.svg" alt="purchase_button" />
          </button>
          <button className="selected">
            <img src="./images/partnership.svg" alt="partnership" />
          </button>
        </InternalMenu>

        {loading ? (
          <RoundContainer>
            <Loading />
          </RoundContainer>

        ) : reportWeeklyMarket?.sales.length === 0 ? (
          <RoundContainer style={{ justifyContent: 'center' }}>
            <p style={{ fontSize: 20, fontWeight: 'bold' }}>Nenhuma venda realizada.</p>
          </RoundContainer>
        ) : null
        }
        {reportWeeklyMarket?.sales?.map((sale, index) => {
          return (
            <RoundContainer key={index}>
              <H2RoundContainer>
                RODADA {sale[0]?.rodada?.numero}
                <img src="./images/icon_playng_game.svg" alt="icon_playng_game" />
              </H2RoundContainer>
              <ParagraphRoundContainer>
                Venda de Produtos
                <div />
              </ParagraphRoundContainer>
              <MainRoundContainer>
                {sale?.map((item, index) => {
                  let imageURL = null
                  if (item?.itemVenda[0].produto.nome === "Peito de Frango") {
                    imageURL = "./images/chicken_orange.svg"
                  } else if (item?.itemVenda[0]?.produto?.nome === "Coxa de Frango") {
                    imageURL = "./images/chicken_cut_orange.svg"
                  } else if (item?.itemVenda[0]?.produto?.nome === "Linguiça Salsichão") {
                    imageURL = "./images/sausage_orange.svg"
                  } else if (item?.itemVenda[0]?.produto?.nome === "Batata Frita") {
                    imageURL = "./images/fries_orange.svg"
                  }
                  return (
                    <div >
                      <img src={imageURL} />
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <p>Quantidade: {item.itemVenda[0].quantidadeTotal}Kg</p>
                        <p>Valor: {item.itemVenda[0].valorTotal}</p>
                      </div>
                    </div>
                  )
                })

                }
              </MainRoundContainer>
            </RoundContainer>
          )
        })

        }

        {/* <RoundContainer>
          <H2RoundContainer className="totalsRound">
            TOTAL DE RODADAS
            <img src="./images/icon_playng_game.svg" alt="icon_playng_game" />
          </H2RoundContainer>
          <ParagraphRoundContainer>
            Compra de insumos
            <div />
          </ParagraphRoundContainer>
          <MainRoundContainer>
            <div>
              <img src="./images/chicken_l_orange.svg" alt="chicken_l_orange" />
              <p>Quantidade: 100Kg</p>
            </div>
            <div>
              <img src="./images/chicken_p_orange.svg" alt="chicken_p_orange" />
              <p>Quantidade: 100Kg</p>
            </div>
            <div>
              <img src="./images/condiment_orange.svg" alt="condiment_orange" />
              <p>Quantidade: 100Kg</p>
            </div>
            <div>
              <img
                src="./images/carry_bag_orange.svg"
                alt="carry_bag_orange
              "
              />
              <p>Quantidade: 100Kg</p>
            </div>
            <div>
              <img src="./images/fries_orange.svg" alt="fries_orange" />
              <p>Quantidade: 100Kg</p>
            </div>
            <div>
              <img src="./images/box_orange.svg" alt="box_orange" />
              <p>Quantidade: 100Kg</p>
            </div>
            <div>
              <img src="./images/pig_orange.svg" alt="pig_orange" />
              <p>Quantidade: 100Kg</p>
            </div>
          </MainRoundContainer>
        </RoundContainer> */}
        <ButtonsMap />
      </SizeContainer>
    </Container>
  );
};
export default WeeklyReportSales;
